import React from 'react';
import styled from '@emotion/styled';
import {
	ProposerRowMobile,
	StyledProposerRowsMobile,
} from '../SolicitationProposersListRowMobile';
import { ShimmerPlaceholderText } from '../../../../../../ui';
import * as ProposerName from '../columns/ProposerName';
import * as ProposerCompany from '../columns/ProposerCompany';
import * as ProposerDbeMwbe from '../columns/ProposerDbeMwbe';
import * as ProposerEmail from '../columns/ProposerEmail';
import * as ProposerPhone from '../columns/ProposerPhone';

export default function SolicitationsProposersListRowShimmerMobile() {
	return (
		<StyledProposerRowsMobile>
			<ProposerRowMobile>
				<ProposerName.MobileHeader />
				<StyledShimmerPlaceholderText />
			</ProposerRowMobile>

			<ProposerRowMobile>
				<ProposerCompany.MobileHeader />
				<StyledShimmerPlaceholderText />
			</ProposerRowMobile>

			<ProposerRowMobile>
				<ProposerDbeMwbe.MobileHeader />
				<StyledShimmerPlaceholderText />
			</ProposerRowMobile>

			<ProposerRowMobile>
				<ProposerEmail.MobileHeader />
				<StyledShimmerPlaceholderText />
			</ProposerRowMobile>

			<ProposerRowMobile>
				<ProposerPhone.MobileHeader />
				<StyledShimmerPlaceholderText />
			</ProposerRowMobile>
		</StyledProposerRowsMobile>
	);
}

const StyledShimmerPlaceholderText = styled(ShimmerPlaceholderText)`
	max-width: 200px;
`;
